import {
  Autocomplete,
  CircularProgress,
  createTheme,
  debounce,
  Paper,
  TextField,
  ThemeProvider,
} from '@mui/material';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSegments } from '../../../utils/store/features/flightSegmentsSlice';
import styles from './FlightSearchAutocomplete.module.scss';
import {getFlightAirportsAutocomplete} from "../../api/flight/autocomplete";

const theme = createTheme({
  shape: {
    borderRadius: 12,
  },
  palette: {
    primary: {
      main: '#00454A',
    },
  },
  typography: {
    fontFamily: '"Libre Franklin", sans-serif',
  },
});
export const FlightSearchAutocomplete = ({
  label,
  showLabel = true,
  icon,
  name,
  setFieldValue,
  error,
  patch,
}) => {
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const [patched, setPatched] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const setInputValue = (value) => {
    setLoading(true);
    getFlightAirportsAutocomplete(value)
      .then((airports) => {
        setOptions(airports);
        setLoading(false);
      })
  };
  const setValue = (newValue) => {
    setFieldValue(name, newValue);
  };
  useEffect(() => {
    if (!!patch?.value && typeof patch.value === 'string') {
      setPatched(true);
      getFlightAirportsAutocomplete(patch.value)
        .then((airports) => {
          const airport =
            patch.exact && airports?.length > 1
              ? airports.find(
                  (a) =>
                    !a.Name.includes('All airports') && a.Iata === patch.value
                )
              : airports.find(
                  (a) => {
                    // a.Iata === patch.value ||
                    // patch.value
                    //   .replaceAll(' ', '')
                    //   .includes(a.city.replaceAll(' ', ''))
                    const cleanedValue = patch.value.replace(/ /g, '');
                    const cleanedCity = a.city.replace(/ /g, '');
                    return a.Iata === patch.value || cleanedValue.includes(cleanedCity);
                  }
                );
          if (airport) {
            airport.exact = patch.exact;
            setValue(airport);
            setPatched(false);
            dispatch(
              setSegments({
                selectedAirport: airport,
                allAirports: airports,
              })
            );
          }
        });
    } else {
      setPatched(true);
    }
  }, [patch.value]);

  return (
    <Autocomplete
      disablePortal={false}
      value={typeof patch.value !== 'string' ? patch.value : null}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      open={open}
      onClose={() => {
        setOpen(false);
        window.parent.postMessage(
          JSON.stringify({
            height: 150,
          }),
          '*'
        );
      }}
      isOptionEqualToValue={(evt) => evt.Name}
      filterOptions={(x) => x}
      onKeyDown={() => {
        setPatched(false);
        setOpen(true);
      }}
      onInputChange={debounce((event, newInputValue, reason) => {
        if (reason === "input") {
          if (newInputValue !== patch.value?.Name && newInputValue.length >= 3) {
            setInputValue(newInputValue);
            return;
          }
          if (patched === false && newInputValue.length >= 3) {
            setInputValue(newInputValue);
            window.parent.postMessage(
              JSON.stringify({
                height: 400,
              }),
              '*'
            );
          }
        }
      }, 500)}
      PaperComponent={({ children }) => (
        <Paper className={cn(styles.option, 'font-libre')}>{children}</Paper>
      )}
      options={options}
      groupBy={(option) => (option.cityName || option.regionName) + (option.countryName ? ' (' + option.countryName + ')' : '')}
      onBlur={() => setOptions([])}
      // getOptionLabel={(option) => (option.fullName || option.name) + option.countryName ? ' (' + option.countryName + ')' : '(none)'}
      getOptionLabel={(option) => (option.fullName || option.name)}
      fullWidth
      renderInput={(params) => (
        <ThemeProvider theme={theme}>
          <TextField
            {...params}
            error={error}
            placeholder={label}
            label={showLabel ? label : undefined}
            InputProps={{
              ...params.InputProps,
              startAdornment: <>{icon}</>,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                </>
              ),
            }}
          />
        </ThemeProvider>
      )}
    />
  );
};
